import {
  Box,
  Button,
  Divider,
  IconButton,
  Typography,
  useTheme,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import interfaceBridge from 'utils/interfaceBridge';

type FormHeaderPropsT = {
  onLeftBtnClick?: () => void;
  onLogBtnClick?: () => void;
  onQueueDisplayBtnClick?: () => void;
};

const academyName = interfaceBridge.getData('ACADEMY_NAME');

function FormHeader({
  onLeftBtnClick: handleLeftBtnClick,
  onLogBtnClick: handleLogBtnClick,
  onQueueDisplayBtnClick: handleQueueDisplayBtnClick,
}: FormHeaderPropsT) {
  const { palette } = useTheme();
  return (
    <>
      <Box
        sx={{
          backgroundColor: palette.background.paper,
          height: '44px',
          flex: '0 0 44px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography
          variant="h5"
          color="white"
          align="center"
          sx={{ userSelect: 'none', letterSpacing: '-1px' }}
        >
          {academyName}
        </Typography>

        <Box
          sx={{
            position: 'absolute',
            left: 0,
            top: 0,
            bottom: 0,
          }}
        >
          <IconButton color="primary" onClick={handleLeftBtnClick}>
            <MenuIcon />
          </IconButton>
        </Box>

        <Box
          sx={{
            position: 'absolute',
            right: 0,
            top: 0,
            bottom: 0,
          }}
        >
          {handleLogBtnClick && (
            <Button
              variant="text"
              onClick={handleLogBtnClick}
              sx={{ px: '12px', minWidth: 0 }}
            >
              로그
            </Button>
          )}
          {handleQueueDisplayBtnClick && (
            <Button
              variant="text"
              onClick={handleQueueDisplayBtnClick}
              sx={{ px: '12px', minWidth: 0 }}
            >
              호출
            </Button>
          )}
        </Box>
      </Box>
      <Divider />
    </>
  );
}

export default FormHeader;
